export enum EGender {
  M,
  F
}

export enum EGenderMap {
  M = 'Boy',
  F = 'Girl'
}